import { render, staticRenderFns } from "./EmployeePolicyForm.vue?vue&type=template&id=5cd23800"
import script from "./EmployeePolicyForm.vue?vue&type=script&lang=js"
export * from "./EmployeePolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports